export default "__VITE_ASSET__9eddbee9__"